import { useEffect, useMemo, useRef } from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import { AppAlertVariant, AppDialog } from '../../types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconProp } from '@fortawesome/fontawesome-svg-core'

interface ModalDialogProps {
    appDialog: AppDialog,
    onClose: VoidFunction,
    onAccept: VoidFunction
}

export default function ModalDialog({ appDialog, onClose, onAccept }: ModalDialogProps) {
    const acceptReference = useRef<HTMLButtonElement>(null);
    const alertIcon = useMemo<IconProp>(() => {
        let map: Map<AppAlertVariant, IconProp> = new Map();
        map.set('info', 'info-circle')
        map.set('warning', 'warning')
        map.set('success', 'check')
        map.set('error', 'times')
        return map.get(appDialog.type) || 'info-circle'
    }, [appDialog.type])

    const defaultAlertTitle = useMemo<string>(() => {
        switch (appDialog.type) {
            case 'error':
                return 'Error'
            case 'info':
                return 'Información'
            case 'success':
                return 'Operación exitosa'
            default:
                return 'Aviso'
        }
    }, [appDialog.type])

    useEffect(() => {
        if (appDialog.open) {
            acceptReference.current?.focus()
        }
    }, [appDialog.open])
    return (
        <Dialog
            open={!!appDialog.open}
            onClose={onClose}
            maxWidth='sm'
            fullWidth
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle>
                <span className='m-auto d-flex-center'>
                    <FontAwesomeIcon icon={alertIcon} style={{ marginRight: '0.5rem' }} />
                    {appDialog.title || defaultAlertTitle}
                </span>
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description" dangerouslySetInnerHTML={{ __html: appDialog.message }} />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} ref={acceptReference}>
                    {appDialog.onAccept ? "Cancelar" : "Aceptar"}
                </Button>
                {appDialog.onAccept && <Button onClick={onAccept} autoFocus>
                    Aceptar
                </Button>}
            </DialogActions>
        </Dialog>
    )
}
